class RomanianRedirectPopup extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      popup: '#RomanianRedirectPopup',
      closeBtn: '.modal-close',
      redirectButton: '.romanian-redirect__button',
      outsideClick: '.modal-dialog',
      insideClick: '.modal-content',
      backdrop: '.modal-backdrop'
    };

    this.elements = {
      popup: this.querySelector(this.selectors.popup),
      closeBtn: this.querySelector(this.selectors.closeBtn),
      redirectButton: this.querySelector(this.selectors.redirectButton),
      outsideClick: this.querySelector(this.selectors.outsideClick),
      insideClick: this.querySelector(this.selectors.insideClick),
      backdrop: this.querySelector(this.selectors.backdrop)
    };

    this.settings = {
      storageKey: 'romanianRedirectCountry',
      countryTimestampKey: 'romanianRedirectCountryTimestamp',
      decisionTimestampKey: 'romanianRedirectDecisionTimestamp',
      oneDayInMs: 24 * 60 * 60 * 1000,
      targetCountry: 'RO'
    };

    this.init();
  }

  async init() {
    const country = await this.getCountry();
    
    if (country === this.settings.targetCountry) {
      const shouldShow = this.shouldShowPopup();
      
      if (shouldShow) {
        this.openPopup();
      }
    }

    this.addListeners();
  }

  async getCountry() {
    const storedCountry = localStorage.getItem(this.settings.storageKey);
    const storedTimestamp = localStorage.getItem(this.settings.countryTimestampKey);
    const currentTime = Date.now();

    // If we have a stored country and it's less than 24 hours old, use it
    if (storedCountry && storedTimestamp) {
      const timeElapsed = currentTime - parseInt(storedTimestamp);
      
      if (timeElapsed < this.settings.oneDayInMs) {
        return storedCountry;
      }
    }

    // Otherwise, fetch new country data
    try {
      const response = await fetch('https://ipapi.co/country/');
      
      if (!response.ok) {
        throw new Error('Failed to fetch country');
      }

      const country = await response.text();
      const trimmedCountry = country.trim();

      // Store country and timestamp
      localStorage.setItem(this.settings.storageKey, trimmedCountry);
      localStorage.setItem(this.settings.countryTimestampKey, currentTime.toString());

      return trimmedCountry;
    } catch (error) {
      console.error('Error fetching country:', error);
      
      // Return stored country as fallback if available
      return storedCountry || null;
    }
  }

  shouldShowPopup() {
    const decisionTimestamp = localStorage.getItem(this.settings.decisionTimestampKey);
    
    // If no decision has been made, show popup
    if (!decisionTimestamp) {
      return true;
    }

    // If decision was made more than 24 hours ago, show popup again
    const currentTime = Date.now();
    const timeElapsed = currentTime - parseInt(decisionTimestamp);
    
    return timeElapsed >= this.settings.oneDayInMs;
  }

  addListeners() {
    if (this.elements.closeBtn) {
      this.elements.closeBtn.addEventListener('click', () => this.closePopup());
    }

    if (this.elements.redirectButton) {
      this.elements.redirectButton.addEventListener('click', (e) => this.handleRedirect(e));
    }

    if (this.elements.outsideClick) {
      this.elements.outsideClick.addEventListener('click', (e) => this.closeModalIfClickOutside(e));
    }

    if (this.elements.backdrop) {
      this.elements.backdrop.addEventListener('click', () => this.closePopup());
    }

    if (this.elements.insideClick) {
      this.elements.insideClick.addEventListener('click', (e) => e.stopPropagation());
    }
  }

  closeModalIfClickOutside(e) {
    if (e.target === this.elements.outsideClick) {
      this.closePopup();
    }
  }

  handleRedirect(e) {
    e.preventDefault();
    const url = this.elements.redirectButton.dataset.url || this.elements.redirectButton.href;
    
    if (url) {
      this.setDecisionTimestamp();
      window.location.href = url;
    }
  }

  openPopup() {
    if (this.elements.popup) {
      this.elements.popup.classList.add('open');
      document.body.classList.add('fixed');
    }
  }

  closePopup() {
    if (this.elements.popup) {
      this.elements.popup.classList.remove('open');
      this.setDecisionTimestamp();
      document.body.classList.remove('fixed');
      
      // Dispatch event to notify other popups that this one closed
      window.dispatchEvent(new CustomEvent('romanian-popup-closed'));
    }
  }

  setDecisionTimestamp() {
    const timestamp = Date.now();
    localStorage.setItem(this.settings.decisionTimestampKey, timestamp.toString());
  }
}

if (!customElements.get('romanian-redirect-popup')) {
  customElements.define('romanian-redirect-popup', RomanianRedirectPopup);
}

